import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import bankService from '../../axios/services/bankService';
import SimpleCard from '../../components/templates/SimpleCard';
import { bankActions } from '../../redux/actions/bankActions';
import Form from './Form';


const CreateTab = () => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = (values) => {
    const data = {
      ...values,
    }

    setIsLoading(true)
    bankService.create(data)
      .then(() => dispatch(bankActions.changeTab(0)))
      .catch(() => setIsLoading(false))
  }

  return (
    <SimpleCard loading={isLoading}>
      <p className="font-500 mb-12">Buat Bank</p>
      <hr />
      <Form onSubmit={onSubmit} />
    </SimpleCard>
  )
}

export default CreateTab
